<template>
  <v-select
      label="Versand"
      clearable
      :multiple="multiple"
      :deletable-chips="multiple"
      :small-chips="multiple"
      :chips="multiple"
      :items="shippings"
      item-value="id"
      item-text="name"
      :value="internalValue"
      v-bind="$attrs"
      @input="onInput"
  />
</template>

<script>
import shippings from '@/assets/shippings'

export default {
  name: 'GhSelectShipping',
  props: {
    value: {
      type: [ Number, Array ],
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
      internalValue: [],
      shippings
  }),
  watch: {
      value: 'setValue'
  },
  methods: {
    /* eslint-disable-next-line no-unused-vars */
    setValue (newValue, oldValue) {
        this.internalValue = newValue
    },
    emitInput () {
        this.$emit('input', this.internalValue)
    },
    onInput (value) {
        this.internalValue = value
        this.emitInput()
    }
  }
}
</script>

<style scoped>

</style>
